import Image from 'next/image';

import styles from './InternalBlogPage.module.scss';

const InternalBlogAuthorSection = ({
  authorDescription,
  authorImageUrl,
  authorName,
}: {
  authorDescription?: string;
  authorImageUrl: string;
  authorName: string;
}) => (
  <div className={styles['blog-author-container']}>
    <div className={styles['blog-author-image-container']}>
      <Image
        className={styles['blog-author-image']}
        alt={authorName}
        width={120}
        height={120}
        src={authorImageUrl}
        unoptimized={true}
      />
    </div>

    <div className={styles['blog-author-detail']}>
      <p className={styles['blog-author-name']}>{authorName}</p>
      {authorDescription && (
        <p className={styles['blog-author-description']}>{authorDescription}</p>
      )}
    </div>
  </div>
);

export default InternalBlogAuthorSection;
